import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { listIndeedFlexShiftIssues } from 'api/admin/indeedFlex/listIndeedFlexShiftIssues'
import { indeedFlexKeys } from './keys'

export function useIndeedFlexShiftIssuesQuery(
  request: Parameters<typeof listIndeedFlexShiftIssues>[0]
) {
  return useQuery({
    queryKey: indeedFlexKeys.shiftIssuesList(request),
    queryFn: () => listIndeedFlexShiftIssues(request),
    placeholderData: keepPreviousData,
  })
}
